import UAParser from 'ua-parser-js';
const uaParser = new UAParser();
enum UserAgentEnum {
	Chrome = 'Chrome',
	Opera = 'Opera',
	Safari = 'Safari',
	Firefox = 'Firefox',
	Windows = 'Windows',
	Chromium = 'Chromium',
}

const KNOWN_BROWSERS = [UserAgentEnum.Chrome, UserAgentEnum.Opera, UserAgentEnum.Safari, UserAgentEnum.Firefox];

const getBrowser = uaParser.getBrowser;
const getOS = uaParser.getOS;
const isWindows: () => boolean = () => !!getOS().name?.toLowerCase().includes(UserAgentEnum.Windows.toLowerCase());
const getBrowserName = () => {
	const browserName = getBrowser().name;
	return KNOWN_BROWSERS.find((name) => browserName?.includes(name)) || browserName;
};

const isUsingChromium: () => boolean = () =>
	!!navigator.userAgentData?.brands.some(({ brand }) => brand.toLowerCase() === UserAgentEnum.Chromium.toLowerCase());

const UserAgentService = {
	getBrowser,
	getOS,
	isWindows,
	getBrowserName,
	isUsingChromium,
};

export default UserAgentService;
